<div class="bulk-wrapper">
  <h2 class="page-title">New Goods Labelling</h2>

  <form class="bulk-form">
    <div class="grid-2">
      <div class="form-group">
        <label>Name <span class="required-star">*</span></label>
        <input
          type="text"
          name="name"
          [(ngModel)]="printLabelModel.name"
          placeholder="Enter name"
        />
      </div>

      <div class="form-group">
        <label>SKU / Barcode <span class="required-star">*</span></label>
        <input
          type="text"
          name="sku"
          [(ngModel)]="printLabelModel.sku"
          placeholder="Enter SKU / Barcode"
          (input)="generateBarcode($event)"
        />
      </div>

      <div class="form-group">
        <label>Store <span class="required-star">*</span></label>
        <select name="store" [(ngModel)]="printLabelModel.storeId" (change)="onStoreChange()">
          <option [ngValue]="null">Select Store</option>
          @for (store of stores; track $index) {
            <option [ngValue]="store.id" (click)="printLabelModel.storeName = store.name">
              {{ store.name }}
            </option>
          }
        </select>
      </div>

      <div class="form-group">
        <label>Brand</label>
        <select name="brand" [(ngModel)]="printLabelModel.brandId" (change)="onBrandChange()">
          <option [ngValue]="null">Select Brand</option>
          @for (brand of brands; track $index) {
            <option [ngValue]="brand.id" (click)="printLabelModel.brandName = brand.name">
              {{ brand.name }}
            </option>
          }
        </select>
      </div>

      <div class="form-group">
        <label>Department</label>
        <select
          name="department"
          (change)="onDepartmentChange()"
          [(ngModel)]="printLabelModel.departmentId"
        >
          <option [ngValue]="null">Select Department</option>
          @for (department of departments; track $index) {
            <option
              [ngValue]="department.id"
              (click)="printLabelModel.departmentName = department.name"
            >
              {{ department.name }}
            </option>
          }
        </select>
      </div>

      <div class="form-group">
        <label>Category</label>
        <select
          name="category"
          [(ngModel)]="printLabelModel.categoryId"
          [disabled]="!printLabelModel.departmentId"
          (change)="onCategoryChange()"
        >
          <option [ngValue]="null">Select Category</option>
          @for (category of productCategories; track $index) {
            <option [ngValue]="category.id" (click)="printLabelModel.categoryName = category.name">
              {{ category.name }}
            </option>
          }
        </select>
      </div>

      <div class="form-group">
        <label>Sub Category</label>
        <select
          name="subCategory"
          [(ngModel)]="printLabelModel.subCategoryId"
          [disabled]="!printLabelModel.categoryId"
          (change)="onSubCategoryChange()"
        >
          <option [ngValue]="null">Select Sub Category</option>
          @for (subCategory of productSubCategories; track $index) {
            <option
              [ngValue]="subCategory.id"
              (click)="printLabelModel.subCategoryName = subCategory.name"
            >
              {{ subCategory.name }}
            </option>
          }
        </select>
      </div>

      <div class="form-group">
        <label>Price <span class="required-star">*</span></label>
        <input
          type="number"
          name="price"
          [(ngModel)]="printLabelModel.price"
          placeholder="Enter Price"
        />
      </div>

      <div class="form-group">
        <label>Size</label>
        <input
          type="text"
          name="sizeSize"
          [(ngModel)]="printLabelModel.sizeSize"
          placeholder="Enter size"
        />
      </div>

      <div class="form-group">
        <label>Color</label>
        <input
          type="text"
          name="color"
          [(ngModel)]="printLabelModel.color"
          placeholder="Enter color"
        />
      </div>

      <div class="form-group">
        <label>Production Cycle</label>
        <select name="productionCycle" [(ngModel)]="printLabelModel.productionCycle">
          <option [ngValue]="null">Select Production Cycle</option>
          @for (productionCycle of productionCycles; track $index) {
            <option [ngValue]="productionCycle.id">
              {{ productionCycle.displayName }}
            </option>
          }
        </select>
      </div>

      <div class="form-group">
        <label>Print Format <span class="required-star">*</span></label>
        <select
          name="format"
          [(ngModel)]="printLabelModel.printFormat"
          (change)="onPrintFormatChange()"
        >
          <option [ngValue]="null">Select Format</option>
          @for (format of labelFormats; track $index) {
            <option [ngValue]="format.id">{{ format.name }}</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label>Quantity to Print <span class="required-star">*</span></label>
        <input
          type="number"
          name="quantity"
          [(ngModel)]="printLabelModel.quantityToPrint"
          placeholder="Enter Quantity"
        />
      </div>
    </div>

    <!-- FOOTER -->
    <div class="form-footer">
      <div class="col-3 ms-1 d-flex align-items-center gap-2">
        <label class="form-label">Preview</label>
        <div class="toggle-wrapper me-2 mb-0">
          <label class="switch">
            <input
              type="checkbox"
              name="preview"
              [checked]="isPreviewEnabled"
              [(ngModel)]="isPreviewEnabled"
            />
            <span class="slider"></span>
          </label>
        </div>
      </div>

      <div class="btn-group">
        <button type="button" class="btn-outline" (click)="onReset()">Reset</button>
        <button
          type="submit"
          class="btn-primary"
          [disabled]="!isValidated()"
          [ngClass]="!isValidated() ? 'disabled' : ''"
          (click)="printLabel()"
        >
          Print
        </button>
      </div>
    </div>
  </form>
</div>

<!-- Preview Modal -->
<button hidden #previewBtn data-bs-target="#exampleModalCenter" data-bs-toggle="modal"></button>
<div
  class="modal fade"
  id="exampleModalCenter"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content image-modal">
      <div class="modal-header justify-content-between align-items-center">
        <h4 style="margin: 0">Preview</h4>
        <button
          type="button"
          class="close-tag"
          data-bs-dismiss="modal"
          aria-label="Close"
          #closeBtn
          style="all: unset; font-size: 2rem"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <img
          *ngIf="labelImg && labelImg.toString().length > 0"
          [src]="labelImg"
          class="previewImg"
        />
        <p *ngIf="!labelImg || labelImg.toString().length === 0" class="invalidMsg">
          Invalid ZPL Code
        </p>
      </div>
    </div>
  </div>
</div>
